import React, { useState } from 'react'
import './Gallery.css'
import { usePhotos } from '../api'
import { Button } from '../../../components/common'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../../store/authStore'

const Gallery: React.FC = () => {
  const { data, isLoading } = usePhotos()
  const navigate = useNavigate()
  const { language } = useAuthStore()
  const photos = data?.data || []
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const [orientation, setOrientation] = useState<
    'portrait' | 'landscape' | null
  >(null)

  if (isLoading) {
    return <div className="text-center py-8">Loading photos...</div>
  }

  if (!photos.length) {
    return <div className="text-center py-8">No photos found.</div>
  }

  const displayedImages = photos.slice(0, 4)

  const handleImageClick = (src: string) => {
    const img = new Image()
    img.src = src
    img.onload = () => {
      if (img.height > img.width) {
        setOrientation('portrait')
      } else {
        setOrientation('landscape')
      }
      setSelectedImage(src)
    }
  }

  return (
    <div className="lg:px-4 py-10">
      <div className="mb-10 w-11/12 mx-auto ">
        <h2 className="text-2xl font-semibold">
          {language === 'lang_mal' ? 'കണ്ണിലൂടെ' : 'Through the Lens'}
        </h2>
        <p className="text-lg font-semibold mb-6">
          {language === 'lang_mal' ? 'ഗ്യാലറി' : 'Gallery'}
        </p>
      </div>

      <div className="py-4 w-11/12 lg:ml-[80px] ml-[16px] relative">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12 pb-6 ">
          {displayedImages.map((item: any, index: number) => (
            <div
              key={item.id || index}
              className="relative w-full h-54 shadow overflow-hidden transition-transform duration-300 rounded-md cursor-pointer"
              onClick={() => handleImageClick(item.file)}
            >
              <img
                src={item.file}
                alt={`Gallery ${index + 1}`}
                className="w-full h-[350px] object-cover bg-white"
              />
            </div>
          ))}
        </div>

        {photos.length > 4 && (
          <div className="flex justify-center mt-6">
            <div className="flex justify-center mt-4">
              <Button
                label={language === 'lang_mal' ? 'കൂടുതൽ കാണുക' : 'View More'}
                className="lg:px-16 lg:min-h-12"
                onClick={() => {
                  navigate('/photo_gallery')
                  window.scrollTo({ top: 0, behavior: 'smooth' })
                }}
              />
            </div>
          </div>
        )}
      </div>

      {/* 🔹 Popup Modal for Image */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className={`relative p-4 bg-white rounded-lg flex justify-center items-center`}
          >
            <img
              src={selectedImage}
              alt="Expanded"
              className={`object-cover rounded-md ${
                orientation === 'portrait'
                  ? 'w-[800px] h-[800px]' // 🔹 fixed ratio for portrait
                  : 'w-[800px] h-[800px]' // 🔹 fixed ratio for landscape
              }`}
            />
            {/* Close Button */}
            <button
              className="absolute top-2 right-2 bg-gray-800 text-white px-3 py-1 rounded-full"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Gallery
